// extracted by mini-css-extract-plugin
module.exports = {"managementList":"ManagementList_managementList__2HXl7","item":"ManagementList_item__28D-i"};